import {Injectable} from '@angular/core';
import {AuthService} from '../../authentication/auth-service';
import {environment} from '../../environments/environment';
import {ApplicationConfiguration} from '../../environments/application-configurations';
import {ForwardConfig, ForwardingStatus, QueueStats} from '../entity/forwarding.model';

@Injectable({providedIn: 'root'})
export class AdminForwardingService {
  private readonly env: ApplicationConfiguration = environment;

  constructor(private readonly authService: AuthService) {}

  async getForwardingStatus(formId: string, version: string): Promise<ForwardingStatus> {
    const response = await fetch(
      `${this.env.claimManagerBackend.baseUrl}/api/admin/forwarding/forms/${formId}/versions/${version}/status`,
      {headers: this.getAuthHeaders()}
    );
    if (!response.ok) throw new Error(response.statusText);
    return response.json();
  }

  async resetDailyCounter(formId: string, version: string): Promise<void> {
    const response = await fetch(
      `${this.env.claimManagerBackend.baseUrl}/api/admin/forwarding/forms/${formId}/versions/${version}/reset-counter`,
      {
        method: 'POST',
        headers: this.getAuthHeaders()
      }
    );
    if (!response.ok) throw new Error(response.statusText);
  }

  async updateConfig(formId: string, version: string, config: ForwardConfig): Promise<void> {
    const response = await fetch(
      `${this.env.claimManagerBackend.baseUrl}/api/admin/forwarding/forms/${formId}/versions/${version}/config`,
      {
        method: 'PUT',
        headers: {...this.getAuthHeaders(), 'Content-Type': 'application/json'},
        body: JSON.stringify(config)
      }
    );
    if (!response.ok) throw new Error(response.statusText);
  }

  async getQueueStats(): Promise<QueueStats> {
    const response = await fetch(
      `${this.env.claimManagerBackend.baseUrl}/api/admin/forwarding/queue/stats`,
      {headers: this.getAuthHeaders()}
    );
    if (!response.ok) throw new Error(response.statusText);
    return response.json();
  }

  async retryFailed(): Promise<void> {
    const response = await fetch(
      `${this.env.claimManagerBackend.baseUrl}/api/admin/forwarding/queue/retry-failed`,
      {
        method: 'POST',
        headers: this.getAuthHeaders()
      }
    );
    if (!response.ok) throw new Error(response.statusText);
  }

  async triggerProcessing(): Promise<void> {
    const response = await fetch(
      `${this.env.claimManagerBackend.baseUrl}/api/admin/forwarding/process`,
      {
        method: 'POST',
        headers: this.getAuthHeaders()
      }
    );
    if (!response.ok) throw new Error(response.statusText);
  }

  private getAuthHeaders(): Record<string, string> {
    const token = this.authService.getIdToken();
    return token ? {'Authorization': `Bearer ${token}`} : {};
  }
}
